<template>
  <v-row
    no-gutters
    dense
  >
    <v-col cols="12">
      <v-card
        outlined
      >
        <v-card-text>
          <v-alert
            v-if="businessCardUrl"
            type="success"
            dense
            outlined
          >
            Your business card is ready.
            <a
              :href="businessCardUrl"
              target="_blank"
              rel="noopener noreferrer"
            >Open business card</a>
          </v-alert>
          <v-row no-gutters dense>
            <v-col cols="12">
              <business-card-iframe
                :vcard-uuid="vcardUuid"
                @business-card-error="handleBusinessCardError"
                @business-card-ready="handleBusinessCardReady"
              ></business-card-iframe>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import BusinessCardIframe from '../../../components/BusinessCardIframe.vue';

export default {
  name: 'BusinessCardGenerator',
  components: {
    BusinessCardIframe,
  },
  data() {
    return {
      vcardUuid: false,
      businessCardUrl: null,
    };
  },
  created() {
    if (this.$route.params.uuid) {
      this.vcardUuid = this.$route.params.uuid;
    }
  },
  methods: {
    handleBusinessCardError(message) {
      this.$store.dispatch('addAlert', {
        id: Date.now(),
        type: 'error',
        message,
      });
    },
    handleBusinessCardReady(url) {
      this.businessCardUrl = url;
      this.$store.dispatch('addAlert', {
        id: Date.now(),
        type: 'success',
        message: 'Your business card is ready. Use the link on this page to open it.',
      });
    },
  },
};
</script>
